import ToggleButton from '@mui/material/ToggleButton';
import { styled } from '@mui/material/styles';

const NRToggleButtonStyled = styled(ToggleButton, {
  shouldForwardProp: prop => prop !== 'minWidth' && prop !== 'useTextColor' && prop !== 'enableDisabledPointerEvents'
})(({ theme, minWidth, useTextColor = false, enableDisabledPointerEvents = false }) => ({
  color: useTextColor ? theme.palette.text.primary : theme.palette.secondary.main,
  ...(minWidth != null && {
    minWidth: theme.spacing(minWidth)
  }),
  '&.Mui-selected': {
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.secondary.main
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.secondary.main
  },
  ...(enableDisabledPointerEvents && {
    '&.Mui-disabled': {
      pointerEvents: 'auto'
    }
  })
}));

export default NRToggleButtonStyled;
